import React from "react";
import { SITE } from "../config/siteConfig";
import { Layout } from "../components/Layout";
import useSeo from "../utils/seo";

export function NotFound() {
  useSeo({
    title: "Página no encontrada",
    description: "Esta página no existe.",
    path: window.location.pathname,
    noindex: true,
  });
  return (
    <Layout>
      <article className="wrap text-page">
        <h1>Página no encontrada</h1>
        <p>La página que buscas no existe o se ha movido.</p>
        <p>
          <a href="/">Volver al inicio de {SITE.brandName}</a>
        </p>
      </article>
    </Layout>
  );
}
